import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet, ActivityIndicator, View} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {apiMasterClin} from '../../../../services/api';
import {EstadosParceirosDTO} from '../../../../dtos/ParceiroDTO';
import {SearchInput} from '../../../../components/Interface/Forms/Inputs/SearchInput';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';
import {LinkButton} from '../../../../components/Interface/Forms/Buttons/LinkButton';
import {NotFound} from '../../../../components/Interface/Search/NotFound';
import {
  FilterItem,
  FilterItemText,
  FilterItemIcon,
  FilterItemRow,
  FilterItemInfo,
} from './filter-components.styles';

interface Props {
  estado?: number;
  onSelectEstado: (value: any) => void;
}

export default function FilterEstadoContent({estado, onSelectEstado}: Props) {
  const [search, setSearch] = useState('');
  const [states, setStates] = useState<EstadosParceirosDTO[]>([]);
  const [filteredStates, setFilteredStates] = useState<EstadosParceirosDTO[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function fetchStates() {
      await apiMasterClin
        .get('/endereco/estados')
        .then((response: any) => {
          const {data} = response.data;
          if (data && isMounted) {
            setStates(data);
            setLoading(false);
          }
        })
        .catch(() => {
          if (isMounted) setLoading(false);
        });
    }

    fetchStates();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSearchStates = (name: string) => {
    const filter = states.filter(
      e =>
        e.nome
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            name
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          ) ||
        e.uf
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            name
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          ),
    );

    setFilteredStates(filter);
    setSearch(name);
  };

  const sortAlphabetically = (data: EstadosParceirosDTO[]) => {
    return data.sort((a: any, b: any) => {
      if (
        a.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '') <
        b.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      ) {
        return -1;
      }
      if (
        a.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '') >
        b.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      ) {
        return 1;
      }
      return 0;
    });
  };

  const displayStates = search.length > 0 ? filteredStates : states;
  const sorted = sortAlphabetically(displayStates);

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <View style={styles.container}>
        <SearchInput
          placeholder="Buscar estado"
          value={search}
          autoCapitalize="sentences"
          onChangeText={handleSearchStates}
        />
        <View style={{marginTop: RFValue(16), flexDirection: 'row',}}>
          <LinkButton
            text="Limpar filtro"
            enabled
            action={() => onSelectEstado(undefined)}
          />
        </View>

        {loading ? (
          <ActivityIndicator size="large" style={styles.loader} />
        ) : sorted.length > 0 ? (
          <ScrollView
            scrollEnabled
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.content}>
            {sorted.map((est, index) => (
              <FilterItem
                key={est.id}
                style={{
                  borderBottomWidth:
                    index === sorted.length - 1 && sorted.length > 1 ? 0 : 1,
                }}
                onPress={() => onSelectEstado(est.id)}>
                <FilterItemRow>
                  <FilterItemInfo>
                    <FilterItemText active={est.id === estado}>
                      {est.nome}
                    </FilterItemText>
                  </FilterItemInfo>
                  <FilterItemIcon
                    name={est.id === estado ? 'check' : 'chevron-right'}
                  />
                </FilterItemRow>
              </FilterItem>
            ))}
          </ScrollView>
        ) : (
          <View style={styles.notFound}>
            <NotFound />
          </View>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: RFValue(24),
    paddingVertical: RFValue(16),
    maxHeight: '98%',
  },
  content: {
    paddingVertical: RFValue(16),
  },
  loader: {
    marginTop: RFValue(20),
  },
  notFound: {
    marginTop: RFValue(20),
  },
});
